/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing system configuration components.
 * @preferred
 * @module SystemModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
    ClrCheckboxModule,
    ClrFormsModule,
    ClrIconModule,
    ClrInputModule,
    ClrTextareaModule,
} from '@clr/angular';

import { AviCardModule } from 'nsx-alb-ui-components';

import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { CoreModule } from 'ng/modules/core/core.module';

import { LicenseQuotaConfigComponent } from 'standalone-components/license-quota-config/license-quota-config.component';
import {
    backupCollectionProvider,
    sslProfileCollectionProvider,
    virtualServiceCollectionProvider,
} from './ajs-upgraded-providers';

import {
    AuthenticationConfig,
    BackupOverviewCardComponent,
    BackupPageComponent,
    CrashReportsPageComponent,
    DnsServiceGridComponent,
    EmailSmtpConfigComponent,
    LocalBackupCardComponent,
    RemoteAuthConfigurationsGridComponent,
    RemoteBackupCardComponent,
    SchedulerModalComponent,
    SystemAboutInfoComponent,
    SystemSettingsAccessConfigContainerComponent,
    SystemSettingsBannersConfigComponent,
    SystemSettingsClientManagementAccessConfigComponent,
    SystemSettingsClientManagementAccessConfigContainerComponent,
    SystemSettingsControllerConfigContainerComponent,
    SystemSettingsDnsNtpConfigComponent,
    SystemSettingsModalComponent,
    SystemSettingsPreviewComponent,
    SystemSettingsSnmpConfigComponent,
    SystemSettingsSyslogConfigComponent,
    SystemSettingsSystemAccessConfigComponent,
    TelemetryConfigComponent,
    TenancyModeConfigComponent,
} from './components';

const systemComponents = [
    AuthenticationConfig,
    BackupOverviewCardComponent,
    BackupPageComponent,
    CrashReportsPageComponent,
    SystemSettingsDnsNtpConfigComponent,
    DnsServiceGridComponent,
    EmailSmtpConfigComponent,
    LocalBackupCardComponent,
    RemoteBackupCardComponent,
    RemoteAuthConfigurationsGridComponent,
    SchedulerModalComponent,
    SystemAboutInfoComponent,
    SystemSettingsAccessConfigContainerComponent,
    SystemSettingsBannersConfigComponent,
    SystemSettingsClientManagementAccessConfigComponent,
    SystemSettingsClientManagementAccessConfigContainerComponent,
    SystemSettingsControllerConfigContainerComponent,
    SystemSettingsModalComponent,
    SystemSettingsPreviewComponent,
    SystemSettingsSnmpConfigComponent,
    SystemSettingsSyslogConfigComponent,
    SystemSettingsSystemAccessConfigComponent,
    TenancyModeConfigComponent,
    TelemetryConfigComponent,
];

@NgModule({
    declarations: [
        ...systemComponents,
    ],
    exports: [
        SystemAboutInfoComponent,
        RemoteAuthConfigurationsGridComponent,
    ],
    imports: [
        AviCardModule,
        AviFormsModule,
        CommonModule,
        DataGridModule,
        FormsModule,
        SharedModule,
        ClrCheckboxModule,
        ClrFormsModule,
        ClrInputModule,
        ClrIconModule,
        ClrTextareaModule,
        CoreModule,
        LicenseQuotaConfigComponent,
    ],
    providers: [
        backupCollectionProvider,
        virtualServiceCollectionProvider,
        sslProfileCollectionProvider,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
})
export class SystemModule { }
